<template>
  <b-container class="form" fluid="true">
    <navbar />
    <p style="font-weight: bolder; font-size: 24px; text-align: center">
      บันทึกข้อมูลแปลงสำรวจ
    </p>
    <!--Section1-->
    <b-row>
      <b-col
        class="rectangle_box py-3 my-3"
        cols="12"
        lg="10"
        md="12"
        sm="12"
        xl="8"
      >
        <b-row class="mx-1">
          <b-col class="d-flex justify-content-start">ข้อมูลทั่วไป</b-col>
          <b-col class="d-flex justify-content-end">
            <span v-if="this.form.plant_code">
              รหัสข้อมูล :{{ this.form.plant_code }}
            </span>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" lg="6" md="6" sm="12">
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left mx-3"
                cols="12"
                lg="3"
                md="10"
                >รหัสชุมชน
                <b-icon icon="info-circle-fill" variant="secondary"></b-icon>
              </b-col>
              <b-col class="text-lg-left text-right" cols="10" md="8" sm="8">
                {{ community_code }}
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left mx-3"
                cols="12"
                lg="3"
                md="10"
                ><b class="font-require">*</b>รหัสพันธุ์พืช
                <b-icon
                  v-b-tooltip.hover.top="getTooltip('รหัสพันธุ์พืช')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-col>
              <b-col class="mx-auto" cols="10" md="8" sm="8">
                <b-form-input
                  readonly
                  id="bio_code"
                  v-model="form.bio_code"
                  class="input_text"
                  placeholder="รหัสพันธุ์ไม้"
                  type="text"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left mx-3"
                cols="12"
                lg="3"
                md="10"
                ><b class="font-require">*</b>ชื่อพืช
                <b-icon
                  v-b-tooltip.hover.top="getTooltip('ชื่อพืช')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-col>
              <b-col class="mx-auto" cols="10" md="8" sm="8">
                <b-form-input
                  v-model="form.bio_name"
                  readonly
                  class="input_text"
                  placeholder="ชื่อพืช"
                  type="text"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left mx-3"
                cols="12"
                lg="3"
                md="10"
                >ชื่อพันธ์ุพืช
                <b-icon
                  v-b-tooltip.hover.top="getTooltip('ชื่อพันธ์ุพืช')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-col>
              <b-col class="mx-auto" cols="10" md="8" sm="8">
                <b-form-input
                  v-model="form.bio_species_name"
                  readonly
                  class="input_text"
                  placeholder="ชื่อพันธ์ุพืช"
                  type="text"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left mx-3"
                cols="12"
                lg="3"
                md="10"
                >ชื่อวงศ์
                <b-icon
                  v-b-tooltip.hover.top="getTooltip('ชื่อวงศ์')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-col>
              <b-col class="mx-auto" cols="10" md="8" sm="8">
                <b-form-input
                  readonly
                  v-model="form.bio_family_name"
                  class="input_text"
                  placeholder="ชื่อวงศ์"
                  type="text"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left mx-3"
                cols="12"
                lg="3"
                md="10"
                >ชื่อวิทยาศาสตร์
                <b-icon
                  v-b-tooltip.hover.top="getTooltip('ชื่อวิทยาศาสตร์')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-col>
              <b-col class="mx-auto" cols="10" md="8" sm="8">
                <b-form-input
                  v-model="form.bio_scientific_name"
                  readonly
                  class="input_text"
                  placeholder="ชื่อวิทยาศาสตร์"
                  type="text"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left mx-3"
                cols="12"
                lg="3"
                md="10"
                >ชื่อผู้ตั้งชนิดพรรณไม้
                <b-icon
                  v-b-tooltip.hover.top="getTooltip('ชื่อผู้ตั้งชนิดพรรณไม้')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-col>
              <b-col class="mx-auto" cols="10" md="8" sm="8">
                <b-form-input
                  v-model="form.author_name"
                  readonly
                  class="input_text"
                  placeholder="ชื่อผู้ตั้งชนิดพรรณไม้"
                  type="text"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left mx-3"
                cols="12"
                lg="3"
                md="10"
                ><b class="font-require">*</b>ชื่อท้องถิ่น
                <b-icon
                  v-b-tooltip.hover.top="getTooltip('ชื่อท้องถิ่น')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-col>
              <b-col class="mx-auto" cols="10" md="8" sm="8">
                <b-form-input
                  v-model="form.bio_local_name"
                  readonly
                  class="input_text"
                  placeholder="ชื่อท้องถิ่น"
                  type="text"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left mx-3"
                cols="12"
                lg="3"
                md="10"
                >ฤดูเก็บเกี่ยว
                <b-icon
                  v-b-tooltip.hover.top="getTooltip('ฤดูเก็บเกี่ยว')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-col>
              <b-col class="mx-auto" cols="10" md="8" sm="8">
                <b-form-input
                  v-model="form.harvest_season"
                  readonly
                  class="input_text"
                  placeholder="ฤดูเก็บเกี่ยว"
                  type="text"
                ></b-form-input>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12" lg="6" md="6" sm="12">
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left mx-3"
                cols="12"
                lg="3"
                md="10"
                ><b class="font-require">*</b>กลุ่มชนิดพืช
                <b-icon
                  v-b-tooltip.hover.top="getTooltip('กลุ่มชนิดพืช')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-col>
              <b-col class="mx-auto" cols="10" md="8" sm="8">
                <multiselect
                  id="categories"
                  v-model="category_selected"
                  :initialValues="category_selected_array"
                  readonly
                  :options="this.categoriesOption"
                  class="multiselect-style2 custom-multiselect"
                  deselect-label="ยกเลิก"
                  :disabled="true"
                  label="name"
                  placeholder="กลุ่มชนิดพืช"
                  select-label=""
                  selectedLabel=""
                  track-by="id"
                  @input="(opt) => (form.category_id = opt.id)"
                ></multiselect>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left mx-3"
                cols="12"
                lg="3"
                md="10"
                ><b class="font-require">*</b>ลักษณะวิสัย
                <b-icon
                  v-b-tooltip.hover.top="getTooltip('ลักษณะวิสัย')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-col>
              <b-col class="mx-auto" cols="10" md="8" sm="8">
                <multiselect
                  readonly
                  id="habit"
                  v-model="habit_selected"
                  :initialValues="habit_selected"
                  :options="this.habitsOption"
                  class="multiselect-style2 custom-multiselect"
                  deselect-label="ยกเลิก"
                  :disabled="true"
                  label="name"
                  placeholder="ลักษณะวิสัย"
                  select-label=""
                  selectedLabel=""
                  track-by="id"
                  @input="(opt) => (form.habit_id = opt.id)"
                ></multiselect>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left mx-3"
                cols="12"
                lg="3"
                md="10"
              >
              </b-col>
              <b-col class="mx-auto" cols="10" md="8" sm="8">
                <b-form-input
                  v-model="form.habit_description"
                  class="input_text"
                  placeholder="คำอธิบายเพิ่มเติม..."
                  readonly
                  type="text"
                ></b-form-input>
              </b-col>
            </b-row>

            <b-row class="mt-3">
              <b-col class="my-2" cols="12" md="12" sm="12">
                <b-row>
                  <b-col
                    align="center"
                    class="text-lg-right text-left mx-3"
                    cols="12"
                    lg="3"
                    md="10"
                    >อายุ/ปี
                    <b-icon
                      v-b-tooltip.hover.top="getTooltip('อายุ')"
                      icon="info-circle-fill"
                      variant="secondary"
                    ></b-icon>
                  </b-col>
                  <b-col class="mx-auto" cols="10" md="8" sm="8">
                    <b-form-input
                      readonly
                      v-model="form.age"
                      class="input_text"
                      max="120"
                      min="0"
                      oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');"
                      onkeydown="if(event.key==='.'){event.preventDefault();}"
                      placeholder="อายุ"
                      type="number"
                    ></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
              <b-col class="my-2" cols="12" md="12" sm="12">
                <b-row>
                  <b-col
                    align="center"
                    class="text-lg-right text-left mx-3"
                    cols="12"
                    lg="3"
                    md="10"
                    readonly
                    >เส้นรอบวง/ซม.
                    <b-icon
                      v-b-tooltip.hover.top="getTooltip('เส้นรอบวง')"
                      icon="info-circle-fill"
                      variant="secondary"
                    ></b-icon>
                  </b-col>
                  <b-col class="mx-auto" cols="10" md="8" sm="8">
                    <b-form-input
                      v-model="form.size"
                      readonly
                      class="input_text"
                      max="120"
                      min="0"
                      oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');"
                      onkeydown="if(event.key==='.'){event.preventDefault();}"
                      placeholder="เส้นรอบวง"
                      type="number"
                    ></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left mx-3"
                cols="12"
                lg="3"
                md="10"
                >ลักษณะเด่น
                <b-icon
                  v-b-tooltip.hover.top="getTooltip('ลักษณะเด่น')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-col>
              <b-col class="mx-auto" cols="10" md="8" sm="8">
                <b-form-input
                  readonly
                  v-model="form.characteristic"
                  class="input_text"
                  placeholder="ลักษณะเด่น"
                  type="text"
                ></b-form-input>
              </b-col>
            </b-row>

            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left mx-3"
                cols="12"
                lg="3"
                md="10"
                ><b class="font-require">*</b>แหล่งที่พบ
                <b-icon
                  v-b-tooltip.hover.top="getTooltip('แหล่งที่พบ')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-col>
              <b-col class="mx-auto" cols="10" md="8" sm="8">
                <multiselect
                  v-if="habitatsOption.length > 0"
                  id="habitat"
                  readonly
                  v-model="habitat_selected"
                  :initialValues="habitat_selected"
                  :options="this.habitatsOption"
                  class="multiselect-style2 custom-multiselect"
                  deselect-label="ยกเลิก"
                  label="name"
                  :disabled="true"
                  placeholder="แหล่งที่พบ"
                  select-label=""
                  selectedLabel=""
                  track-by="name"
                  @input="(opt) => (form.habitat = opt.id)"
                ></multiselect>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left mx-3"
                cols="12"
                lg="3"
                md="10"
              >
              </b-col>
              <b-col class="mx-auto" cols="10" md="8" sm="8">
                <b-form-input
                  v-model="form.habitat_description"
                  readonly
                  class="input_text"
                  placeholder="คำอธิบายเพิ่มเติม..."
                  type="text"
                ></b-form-input>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <br />
    <!--Section2-->
    <b-row>
      <b-col
        class="rectangle_box py-3 my-3"
        cols="12"
        lg="10"
        md="12"
        sm="12"
        xl="8"
      >
        <b-row>
          <b-col>
            <b-row class="mx-1">
              <b-col class="d-flex justify-content-start"
                >การใช้ประโยชน์ในท้องถิ่น
                <b-icon
                  v-b-tooltip.hover.top="getTooltip('การใช้ประโยชน์ในท้องถิ่น')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-col>
            </b-row>
            <span v-for="(option, i) in benefitsOption" :key="option.id">
              <b-row v-if="form.benefit[i]" class="mt-3">
                <b-col
                  align="center"
                  class="text-left mx-3 px-5"
                  cols="12"
                  lg="2"
                  md="2"
                  offset-lg="2"
                  offset-md="2"
                  offset-sm="2"
                  offset-xl="2"
                  sm="2"
                  xl="2"
                >
                  <b-form-checkbox
                    :disabled="true"
                    @change="onBenefitCheckbox($event, i)"
                    v-model="form.benefit[i].isChecked"
                  >
                    {{ option.name }}
                  </b-form-checkbox>
                </b-col>
                <b-col class="mx-auto" cols="10" lg="9" md="9" sm="9" xl="9">
                  <b-form-input
                    v-model="form.benefit[i].benefit_description"
                    :disabled="true"
                    :placeholder="'คำอธิบายของ' + `${option.name}`"
                    class="input_text"
                    type="text"
                  ></b-form-input>
                </b-col>
              </b-row>
            </span>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <br />
    <!--Section3-->
    <b-row>
      <b-col
        class="rectangle_box py-3 my-3"
        cols="12"
        lg="10"
        md="12"
        sm="12"
        xl="8"
      >
        <b-row>
          <b-col>
            <b-row class="mx-1">
              <b-col class="d-flex justify-content-start"
                >ภูมิปัญญาท้องถิ่น
                <b-icon
                  v-b-tooltip.hover.top="getTooltip('ภูมิปัญญาท้องถิ่น')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-col>
            </b-row>
            <span v-for="(knowledgeLvl_1, i) in knowledge" :key="i">
              <b-row class="mt-3 my-3">
                <b-col align="center" class="text-left mx-5 my-3" cols="12">
                  <b-form-checkbox
                    :disabled="true"
                    :ref="'checkLvl1_' + i"
                    v-model="
                      checkInput[
                        knowledgeLvl_1[0].knowledge.knowledge_level1_id
                      ]
                    "
                    @change="onKnowledgeLvl1Checkbox($event, knowledgeLvl_1)"
                  >
                    {{ knowledgeLvl_1[0].knowledge.name }}
                  </b-form-checkbox>
                </b-col>
                <b-col class="mx-auto" cols="10" lg="9" md="9" sm="9" xl="9">
                  <span v-for="(knowledgeLvl_2, j) in knowledgeLvl_1" :key="j">
                    <b-row>
                      <b-col
                        class="mx-auto text-left"
                        cols="10"
                        lg="4"
                        md="4"
                        sm="4"
                        xl="4"
                      >
                        <b-form-checkbox
                          readonly
                          :ref="
                            'checkLvl2_' + knowledgeLvl_2.knowledge_level2_id
                          "
                          @change="onKnowledgeCheckbox($event, knowledgeLvl_2)"
                          v-model="
                            checkInput[
                              knowledgeLvl_2.knowledge_level1_id +
                                '_' +
                                knowledgeLvl_2.knowledge_level2_id
                            ]
                          "
                          :disabled="true"
                        >
                          {{ knowledgeLvl_2.name }}
                        </b-form-checkbox>
                      </b-col>
                      <b-col
                        class="mx-auto"
                        cols="10"
                        lg="8"
                        md="8"
                        sm="8"
                        xl="8"
                      >
                        <b-form-input
                          v-if="
                            form.knowledge[knowledgeLvl_2.knowledge_level2_id]
                          "
                          readonly
                          :ref="'text' + knowledgeLvl_2.knowledge_level2_id"
                          v-model="
                            form.knowledge[knowledgeLvl_2.knowledge_level2_id]
                              .knowledge_description
                          "
                          :placeholder="
                            'คำอธิบายของ' + `${knowledgeLvl_2.name}`
                          "
                          :disabled="
                            !checkInput[
                              knowledgeLvl_2.knowledge_level1_id +
                                '_' +
                                knowledgeLvl_2.knowledge_level2_id
                            ]
                          "
                          class="input_text my-2"
                          type="text"
                        ></b-form-input>

                        <b-form-input
                          v-else
                          readonly
                          :ref="'text' + knowledgeLvl_2.knowledge_level2_id"
                          v-model="
                            form.knowledge[knowledgeLvl_2.knowledge_level2_id]
                          "
                          :placeholder="
                            'คำอธิบายของ' + `${knowledgeLvl_2.name}`
                          "
                          :disabled="
                            !checkInput[
                              knowledgeLvl_2.knowledge_level1_id +
                                '_' +
                                knowledgeLvl_2.knowledge_level2_id
                            ]
                          "
                          class="input_text my-2"
                          type="text"
                        ></b-form-input>
                      </b-col>
                    </b-row>
                  </span>
                </b-col>
              </b-row>
            </span>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <br />
    <!--Section4-->
    <b-row>
      <b-col
        class="rectangle_box py-3 my-3"
        cols="12"
        lg="10"
        md="12"
        sm="12"
        xl="8"
      >
        <b-row class="mx-1">
          <b-col class="d-flex justify-content-start">ข้อมูลสำรวจ</b-col>
        </b-row>
        <b-row>
          <b-col cols="12" lg="6" md="6" sm="12">
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left mx-3"
                cols="12"
                lg="3"
                md="10"
                ><b class="font-require">*</b>วันที่สำรวจพบ
                <b-icon
                  v-b-tooltip.hover.top="getTooltip('วันที่สำรวจพบ')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-col>
              <b-col class="mx-auto" cols="10" md="7" sm="8">
                <b-form-input
                  v-model="form.survey_date"
                  readonly
                  class="input_text w-100"
                  style="height: 38px"
                  type="date"
                />
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left mx-3"
                cols="12"
                lg="3"
                md="10"
                >จำนวน/ต้น
                <b-icon
                  v-b-tooltip.hover.top="getTooltip('จำนวน')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-col>
              <b-col class="mx-auto" cols="10" md="7" sm="8">
                <b-form-input
                  v-model="form.survey_amount"
                  readonly
                  class="input_text"
                  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');"
                  onkeydown="if(event.key==='.'){event.preventDefault();}"
                  placeholder="จำนวน"
                  type="number"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col class="my-2" cols="12" md="12" sm="12">
                <b-row>
                  <b-col
                    align="center"
                    class="text-lg-right text-left mx-3"
                    cols="12"
                    lg="3"
                    md="10"
                    ><b class="font-require">*</b>พิกัดต้นพันธุ์
                    <b-icon
                      v-b-tooltip.hover.top="getTooltip('พิกัดต้นพันธุ์')"
                      icon="info-circle-fill"
                      variant="secondary"
                    ></b-icon>
                  </b-col>
                  <b-col class="mx-auto" cols="10" md="7" sm="8">
                    <b-row>
                      <b-col>
                        <b-form-input
                          v-model="form.survey_bio_lat"
                          class="input_text"
                          placeholder="ละติจูด"
                          readonly
                          type="number"
                        ></b-form-input>
                      </b-col>
                      <b-col>
                        <b-form-input
                          readonly
                          v-model="form.survey_bio_lon"
                          class="input_text"
                          placeholder="ลองติจูด"
                          type="number"
                        ></b-form-input>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
              <b-col class="my-2" cols="12" md="12" sm="12"></b-col>
            </b-row>
          </b-col>
          <b-col cols="12" lg="6" md="6" sm="12">
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left mx-3"
                cols="12"
                lg="3"
                md="10"
                >รหัสแปลงสำรวจ
                <b-icon
                  v-b-tooltip.hover.top="getTooltip('รหัสแปลงสำรวจ')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-col>
              <b-col class="mx-auto" cols="10" md="7" sm="8">
                <b-form-input
                  v-model="form.survey_plot_code"
                  class="input_text"
                  readonly
                  placeholder="รหัสแปลงธนาคาร"
                  type="text"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left mx-3"
                cols="12"
                lg="3"
                md="10"
                >ชื่อแปลง
                <b-icon
                  v-b-tooltip.hover.top="getTooltip('ชื่อแปลง')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-col>
              <b-col class="mx-auto" cols="10" md="7" sm="8">
                <b-form-input
                  v-model="form.survey_plot_name"
                  readonly
                  class="input_text"
                  placeholder="ชื่อแปลง"
                  type="text"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left mx-3"
                cols="12"
                lg="3"
                md="10"
                >ที่ตั้งแปลง
                <b-icon
                  v-b-tooltip.hover.top="getTooltip('ที่ตั้งแปลง')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-col>
              <b-col class="mx-auto" cols="10" md="7" sm="8">
                <b-form-input
                  v-model="form.survey_plot_address"
                  readonly
                  class="input_text"
                  placeholder="ที่ตั้งแปลง"
                  type="text"
                ></b-form-input>
              </b-col>
            </b-row>

            <b-row class="mt-3">
              <b-col class="my-2" cols="12" md="12" sm="12">
                <b-row>
                  <b-col
                    align="center"
                    class="text-lg-right text-left mx-3"
                    cols="12"
                    lg="3"
                    md="10"
                    >จังหวัด
                  </b-col>
                  <b-col class="mx-auto" cols="10" md="7" sm="8">
                    <multiselect
                      id="survey_plot_province"
                      v-model="province_survey_selected"
                      readonly
                      :initialValues="province_survey_selected"
                      :options="this.province_survey"
                      class="multiselect-style2 custom-multiselect"
                      deselect-label="ยกเลิก"
                      label="name"
                      :disabled="true"
                      placeholder="จังหวัด"
                      select-label=""
                      selectedLabel=""
                      track-by="id"
                      @input="getDistrict(province_survey_selected, 'survey')"
                      @select="(opt) => (form.survey_plot_province = opt.code)"
                    ></multiselect>
                  </b-col>
                </b-row>
              </b-col>
              <b-col class="my-2" cols="12" md="12" sm="12">
                <b-row>
                  <b-col
                    align="center"
                    class="text-lg-right text-left mx-3"
                    cols="12"
                    lg="3"
                    md="10"
                    >อำเภอ
                  </b-col>
                  <b-col class="mx-auto" cols="10" md="7" sm="8">
                    <multiselect
                      id="survey_plot_district"
                      readonly
                      v-model="district_survey_selected"
                      :disabled="true"
                      :initialValues="this.district_survey_selected"
                      :options="this.district_survey"
                      class="multiselect-style2 custom-multiselect"
                      deselect-label="ยกเลิก"
                      label="name"
                      placeholder="อำเภอ"
                      select-label=""
                      selectedLabel=""
                      track-by="name"
                      @input="
                        getSubDistrict(district_survey_selected, 'survey')
                      "
                      @select="
                        (opt) => (form.survey_plot_district = opt.district_id)
                      "
                    ></multiselect>
                  </b-col>
                </b-row>
              </b-col>
              <b-col class="my-2" cols="12" md="12" sm="12">
                <b-row>
                  <b-col
                    align="center"
                    class="text-lg-right text-left mx-3"
                    cols="12"
                    lg="3"
                    md="10"
                    >ตำบล
                  </b-col>
                  <b-col class="mx-auto" cols="10" md="7" sm="8">
                    <multiselect
                      id="survey_plot_sub_district"
                      v-model="sub_district_survey_selected"
                      readonly
                      :disabled="true"
                      :initialValues="this.sub_district_survey_selected"
                      :options="this.sub_district_survey"
                      class="multiselect-style2 custom-multiselect"
                      deselect-label="ยกเลิก"
                      label="name"
                      placeholder="ตำบล"
                      select-label=""
                      selectedLabel=""
                      track-by="name"
                      @input="
                        (opt) =>
                          (form.survey_plot_sub_district = opt.subdistrict_id)
                      "
                      @select="this.sub_district_survey_selected"
                    ></multiselect>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col class="my-2" cols="12" md="12" sm="12">
                <b-row>
                  <b-col
                    align="center"
                    class="text-lg-right text-left mx-3"
                    cols="12"
                    lg="3"
                    md="10"
                    >พิกัดแปลง
                    <b-icon
                      v-b-tooltip.hover.top="getTooltip('พิกัดแปลง')"
                      icon="info-circle-fill"
                      variant="secondary"
                    ></b-icon>
                  </b-col>
                  <b-col class="mx-auto" cols="10" md="7" sm="8">
                    <b-row>
                      <b-col>
                        <b-form-input
                          v-model="form.survey_plot_lat"
                          class="input_text"
                          readonly
                          placeholder="ละติจูด"
                          type="number"
                        ></b-form-input>
                      </b-col>
                      <b-col>
                        <b-form-input
                          v-model="form.survey_plot_lon"
                          class="input_text"
                          placeholder="ลองติจูด"
                          readonly
                          type="number"
                        ></b-form-input>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <br />
    <!--Section5-->
    <b-row>
      <b-col
        class="rectangle_box py-3 my-3"
        cols="12"
        lg="10"
        md="12"
        sm="12"
        xl="8"
      >
        <b-row class="mx-1">
          <b-col class="d-flex justify-content-start">ข้อมูลแปลงธนาคาร</b-col>
        </b-row>
        <b-row>
          <b-col cols="12" lg="6" md="6" sm="12">
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left mx-3"
                cols="12"
                lg="3"
                md="10"
                ><b class="font-require">*</b>วันที่จัดเก็บ
                <b-icon
                  v-b-tooltip.hover.top="getTooltip('วันที่จัดเก็บ')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-col>
              <b-col class="mx-auto" cols="10" md="7" sm="8">
                <b-form-input
                  v-model="form.bank_date"
                  readonly
                  class="input_text w-100"
                  style="height: 38px"
                  type="date"
                />
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left mx-3"
                cols="12"
                lg="3"
                md="10"
                >จำนวน/ต้น
                <b-icon
                  v-b-tooltip.hover.top="getTooltip('จำนวน')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-col>
              <b-col class="mx-auto" cols="10" md="7" sm="8">
                <b-form-input
                  v-model="form.bank_amount"
                  readonly
                  class="input_text bank"
                  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');"
                  onkeydown="if(event.key==='.'){event.preventDefault();}"
                  placeholder="จำนวน"
                  type="number"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col class="my-2" cols="12" md="12" sm="12">
                <b-row>
                  <b-col
                    align="center"
                    class="text-lg-right text-left mx-3"
                    cols="12"
                    lg="3"
                    md="10"
                    >พิกัดต้นพันธุ์
                    <b-icon
                      v-b-tooltip.hover.top="getTooltip('พิกัดต้นพันธุ์')"
                      icon="info-circle-fill"
                      variant="secondary"
                    ></b-icon>
                  </b-col>
                  <b-col class="mx-auto" cols="10" md="7" sm="8">
                    <b-row>
                      <b-col>
                        <b-form-input
                          v-model="form.bank_bio_lat"
                          readonly
                          class="input_text"
                          placeholder="ละติจูด"
                          type="number"
                        ></b-form-input>
                      </b-col>
                      <b-col>
                        <b-form-input
                          v-model="form.bank_bio_lon"
                          readonly
                          class="input_text"
                          placeholder="ลองติจูด"
                          type="number"
                        ></b-form-input>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12" lg="6" md="6" sm="12">
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left mx-3"
                cols="12"
                lg="3"
                md="10"
                >รหัสแปลงธนาคาร
                <b-icon
                  v-b-tooltip.hover.top="getTooltip('รหัสแปลงธนาคาร')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-col>
              <b-col class="mx-auto" cols="10" md="7" sm="8">
                <b-form-input
                  v-model="form.bank_plot_code"
                  readonly
                  class="input_text bank"
                  placeholder="รหัสแปลงธนาคาร"
                  type="text"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left mx-3"
                cols="12"
                lg="3"
                md="10"
                >ชื่อแปลง
                <b-icon
                  v-b-tooltip.hover.top="getTooltip('ชื่อแปลง')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-col>
              <b-col class="mx-auto" cols="10" md="7" sm="8">
                <b-form-input
                  v-model="form.bank_plot_name"
                  readonly
                  class="input_text bank"
                  placeholder="ชื่อแปลง"
                  type="text"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-left mx-3"
                cols="12"
                lg="3"
                md="10"
                ><b class="font-require">*</b>ที่ตั้งแปลง
                <b-icon
                  v-b-tooltip.hover.top="getTooltip('ที่ตั้งแปลง')"
                  icon="info-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-col>
              <b-col class="mx-auto" cols="10" md="7" sm="8">
                <b-form-input
                  v-model="form.bank_plot_address"
                  readonly
                  class="input_text bank"
                  placeholder="ที่ตั้งแปลง"
                  type="text"
                ></b-form-input>
              </b-col>
            </b-row>

            <b-row class="mt-3">
              <b-col class="my-2" cols="12" md="12" sm="12">
                <b-row>
                  <b-col
                    align="center"
                    class="text-lg-right text-left mx-3"
                    cols="12"
                    lg="3"
                    md="10"
                    ><b class="font-require">*</b>จังหวัด
                  </b-col>
                  <b-col class="mx-auto" cols="10" md="7" sm="8">
                    <multiselect
                      id="bank_plot_province"
                      :disabled="true"
                      v-model="province_bank_selected"
                      :initialValues="this.province_bank_selected"
                      :options="this.province_bank"
                      class="multiselect-style2 custom-multiselect"
                      deselect-label="ยกเลิก"
                      label="name"
                      placeholder="จังหวัด"
                      select-label=""
                      selectedLabel=""
                      track-by="name"
                      @input="getDistrict(province_bank_selected, 'bank')"
                      @select="(opt) => (form.bank_plot_province = opt.code)"
                    ></multiselect>
                  </b-col>
                </b-row>
              </b-col>
              <b-col class="my-2" cols="12" md="12" sm="12">
                <b-row>
                  <b-col
                    align="center"
                    class="text-lg-right text-left mx-3"
                    cols="12"
                    lg="3"
                    md="10"
                    ><b class="font-require">*</b>อำเภอ
                  </b-col>
                  <b-col class="mx-auto" cols="10" md="7" sm="8">
                    <multiselect
                      id="bank_plot_district"
                      readonly
                      v-model="district_bank_selected"
                      :disabled="true"
                      :initialValues="this.district_bank_selected"
                      :options="this.district_bank"
                      class="multiselect-style2 custom-multiselect"
                      deselect-label="ยกเลิก"
                      label="name"
                      placeholder="อำเภอ"
                      select-label=""
                      selectedLabel=""
                      track-by="name"
                      @input="getSubDistrict(district_bank_selected, 'bank')"
                      @select="
                        (opt) => (form.bank_plot_district = opt.district_id)
                      "
                    ></multiselect>
                  </b-col>
                </b-row>
              </b-col>
              <b-col class="my-2" cols="12" md="12" sm="12">
                <b-row>
                  <b-col
                    align="center"
                    class="text-lg-right text-left mx-3"
                    cols="12"
                    lg="3"
                    md="10"
                    ><b class="font-require">*</b>ตำบล
                  </b-col>
                  <b-col class="mx-auto" cols="10" md="7" sm="8">
                    <multiselect
                      id="bank_plot_sub_district"
                      v-model="sub_district_bank_selected"
                      :disabled="true"
                      :initialValues="this.sub_district_bank_selected"
                      :options="this.sub_district_bank"
                      class="multiselect-style2 custom-multiselect"
                      deselect-label="ยกเลิก"
                      label="name"
                      placeholder="ตำบล"
                      select-label=""
                      selectedLabel=""
                      track-by="name"
                      @input="
                        (opt) =>
                          (form.bank_plot_sub_district = opt.subdistrict_id)
                      "
                      @select="sub_district_bank_selected"
                    ></multiselect>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col class="my-2" cols="12" md="12" sm="12">
                <b-row>
                  <b-col
                    align="center"
                    class="text-lg-right text-left mx-3"
                    cols="12"
                    lg="3"
                    md="10"
                    ><b class="font-require">*</b>พิกัดแปลง
                    <b-icon
                      v-b-tooltip.hover.top="getTooltip('พิกัดแปลง')"
                      icon="info-circle-fill"
                      variant="secondary"
                    ></b-icon>
                  </b-col>
                  <b-col class="mx-auto" cols="10" md="7" sm="8">
                    <b-row>
                      <b-col>
                        <b-form-input
                          v-model="form.bank_plot_lat"
                          readonly
                          class="input_text"
                          placeholder="ละติจูด"
                          type="number"
                        ></b-form-input>
                      </b-col>
                      <b-col>
                        <b-form-input
                          v-model="form.bank_plot_lon"
                          readonly
                          class="input_text"
                          placeholder="ลองติจูด"
                          type="number"
                        ></b-form-input>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <br />
    <!--Section6-->
    <b-row>
      <b-col
        class="rectangle_box py-3 my-3"
        cols="12"
        lg="10"
        md="12"
        sm="12"
        xl="8"
      >
        <b-row class="mx-1">
          <b-col>
            <p>รูปภาพ</p>
            <div class="row">
              <div class="offset-1"></div>
              <div
                class="col-6 col-md-2 my-3"
                v-for="(item, i) in this.form.images"
                :key="i"
              >
                <img
                  class="mr-3 fluid"
                  style="width: 100px; height: 100px"
                  :src="item.image_url"
                  alt=""
                />
              </div>
            </div>
            <!--            <b-row>-->
            <!--              <b-col class="col-2 offset-1" v-for="item in this.form.images">-->
            <!--                <b-img :src="item" width="50px" height="50px"></b-img>-->
            <!--              </b-col>-->
            <!--              <b-col v-if="this.form.images.length < 5">-->
            <!--                <b-btn-->
            <!--                  style="color: #db7f50"-->
            <!--                  class="btn-form btn-orange"-->
            <!--                  @click="chooseFiles()"-->
            <!--                >-->
            <!--                  <b-icon icon="plus-circle-fill" class="my-1"></b-icon>-->
            <!--                </b-btn>-->
            <!--                <b-form-file-->
            <!--                  id="imgUpload"-->
            <!--                  type="file"-->
            <!--                  accept="image/*"-->
            <!--                  hidden-->
            <!--                  @change="uploadImage"-->
            <!--                  style="display: none !important"-->
            <!--                />-->
            <!--              </b-col>-->
            <!--            </b-row>-->
          </b-col>
          <!--            <template>-->
          <!--              &lt;!&ndash;              <input&ndash;&gt;-->
          <!--              &lt;!&ndash;                id="fileUpload"&ndash;&gt;-->
          <!--              &lt;!&ndash;                @input="addImage($event)"&ndash;&gt;-->
          <!--              &lt;!&ndash;                type="file"&ndash;&gt;-->
          <!--              &lt;!&ndash;                hidden&ndash;&gt;-->
          <!--              &lt;!&ndash;                accept="image/*"&ndash;&gt;-->
          <!--              &lt;!&ndash;              />&ndash;&gt;-->
          <!--              &lt;!&ndash;              <button @click="uploaderImage()">Choose</button>&ndash;&gt;-->
          <!--              <uploader-->
          <!--                v-model="fileList"-->
          <!--                :autoUpload="false"-->
          <!--                @on-change="addImage"-->
          <!--              ></uploader>-->
          <!--            </template>-->
        </b-row>
      </b-col>
    </b-row>
    <br />
    <!--Section submit-->
    <b-row>
      <b-col cols="12" lg="6" offset-lg="3" md="12" sm="12" xl="6">
        <template>
          <b-button
            class="text-center my-2 pb-3 btn btn-block btn-outline-secondary"
            style="border-radius: 25px; color: white"
            to="/Result"
          >
            ยกเลิก
          </b-button>
        </template>
        <!--        <template v-else>-->
        <!--          <b-button-->
        <!--            class="text-center my-2 pb-3 btn btn-block"-->
        <!--            style="background: white; border-radius: 25px; color: #bdbdbd"-->
        <!--            to="/Survey"-->
        <!--          >-->
        <!--            ยกเลิก-->
        <!--          </b-button>-->
        <!--        </template>-->
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import navbar from "@/components/navbar";
import Multiselect from "vue-multiselect";
import { mapState } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "plantInfo",
  data() {
    return {
      community_code: "",
      markers_survay_bio: [],
      markers_survay_plot: [],
      markers_bank_bio: [],
      markers_bank_plot: [],
      startLocation: {
        lat: 13.7649084,
        lng: 100.5382846,
      },
      plainText: "",
      SwitchData: true,
      category_selected: [],
      category_selected_array: [],
      habit_selected: [],
      habitat_selected: [],
      categoriesOption: [],
      province_survey_selected: [],
      district_survey_selected: [],
      sub_district_survey_selected: [],
      province_bank_selected: [],
      district_bank_selected: [],
      sub_district_bank_selected: [],
      habitsOption: [],
      habitatsOption: [],
      benefitsOption: [],
      benefitsRemarkValue: [],
      knowledgeOption: [],
      checkInput: [],
      checkInputs: [],
      fileList: [],
      image: null,
      tooltipName: [
        {
          name: "วันที่จัดเก็บ",
          tooltip_name: "เลือกวันที่ที่ทำการจัดเก็บพันธุ์พืช",
        },
        { name: "จำนวน", tooltip_name: "ระบุจำนวนต้นที่จัดเก็บ" },
        {
          name: "พิกัดพันธุ์พืช",
          tooltip_name: "ระบุพิกัดต้นพันธุ์ เป็นละติจูดและลองติจูด",
        },
        { name: "รหัสแปลงธนาคาร", tooltip_name: "ระบุรหัสของแปลงธนาคาร" },
        { name: "ชื่อแปลง", tooltip_name: "ระบุชื่อแปลงธนาคาร" },
        {
          name: "ที่ตั้งแปลง",
          tooltip_name: "ระบุที่ตั้งแปลงธนาคาร เช่น ตำบล อำเภอ จังหวัด",
        },
        {
          name: "พิกัดแปลง",
          tooltip_name: "ระบุพิกัดแปลง เป็นละติจูดและลองติจูด",
        },
        {
          name: "รหัสพันธุ์พืช",
          tooltip_name: "ระบุรหัสพันธุ์พืช ที่เป็นรหัสที่ใช้เรียกในชุมชน",
        },
        { name: "ชื่อพืช", tooltip_name: "ระบุชื่อพืช" },
        {
          name: "ชื่อวิทยาศาสตร์",
          tooltip_name: "ระบุชื่อวิทยาศาสตร์ของพืช",
        },
        {
          name: "ชื่อผู้ตั้งชนิดพรรณไม้",
          tooltip_name: "ระบุชื่อผู้ตั้งชนิดพรรณไม้ของพืช",
        },
        {
          name: "ชื่อวงศ์",
          tooltip_name: "ระบุชื่อวงศ์ของพืช",
        },
        {
          name: "ชื่อพันธ์ุพืช",
          tooltip_name: "ระบุชื่อพันธ์ุพืช",
        },
        {
          name: "ชื่อท้องถิ่น",
          tooltip_name: "ระบุชื่อพืชที่ใช้เรียกในท้องถิ่น",
        },
        {
          name: "ฤดูเก็บเกี่ยว",
          tooltip_name: "ระบุฤดูที่สามารถเก็บเกี่ยวได้",
        },
        { name: "กลุ่มชนิดพืช", tooltip_name: "เลือกกลุ่มชนิดพืช" },
        { name: "ลักษณะวิสัย", tooltip_name: "เลือกลักษณะวิสัย" },
        { name: "อายุ", tooltip_name: "ระบุอายุของพันธุ์พืช" },
        { name: "เส้นรอบวง", tooltip_name: "ระบุขนาดเส้นรอบวงเป็นเซนติเมตร" },
        { name: "ลักษณะเด่น", tooltip_name: "อธิบายลักษณะเด่นของพันธุ์พืช" },
        {
          name: "แหล่งที่พบ",
          tooltip_name: "เลือกแหล่งที่พบ และอธิบายเพิ่มเติม",
        },
        {
          name: "การใช้ประโยชน์ในท้องถิ่น",
          tooltip_name: "เลือกส่วนที่สามารถนำไปใช้ประโยชน์ และอธิบายประโยชน์",
        },
        {
          name: "ภูมิปัญญาท้องถิ่น",
          tooltip_name:
            "เลือกการใช้ประโยชน์ในเชิงภูมิปัญญาของท้องถิ่น และอธิบายเพิ่มเติม",
        },
        {
          name: "วันที่สำรวจพบ",
          tooltip_name: "เลือกวันที่ที่ทำการสำรวจพันธุ์พืช",
        },
        { name: "จำนวน", tooltip_name: "ระบุจำนวนต้นที่สำรวจพบ" },
        {
          name: "พิกัดพันธุ์",
          tooltip_name: "ระบุพิกัดต้นพันธุ์ เป็นละติจูดและลองติจูด",
        },
        { name: "รหัสแปลงสำรวจ", tooltip_name: "ระบุรหัสของแปลงสำรวจ" },
        { name: "ชื่อแปลง", tooltip_name: "ระบุชื่อแปลงสำรวจ" },
        {
          name: "ที่ตั้งแปลง",
          tooltip_name: "ระบุที่ตั้งแปลงสำรวจ เช่น ตำบล อำเภอ จังหวัด",
        },
        {
          name: "พิกัดแปลง",
          tooltip_name: "ระบุพิกัดแปลง เป็นละติจูดและลองติจูด",
        },
        {
          name: "วันที่จัดเก็บ",
          tooltip_name: "เลือกวันที่ที่ทำการจัดเก็บพันธุ์พืช",
        },
        { name: "จำนวน", tooltip_name: "ระบุจำนวนต้นที่จัดเก็บ" },
        {
          name: "พิกัดต้นพันธุ์",
          tooltip_name: "ระบุพิกัดต้นพันธุ์ เป็นละติจูดและลองติจูด",
        },
        { name: "รหัสแปลงธนาคาร", tooltip_name: "ระบุรหัสของแปลงธนาคาร" },
        { name: "ชื่อแปลง", tooltip_name: "ระบุชื่อแปลงธนาคาร" },
        {
          name: "ที่ตั้งแปลง",
          tooltip_name: "ระบุที่ตั้งแปลงธนาคาร เช่น ตำบล อำเภอ จังหวัด",
        },
        {
          name: "พิกัดแปลง",
          tooltip_name: "ระบุพิกัดแปลง เป็นละติจูดและลองติจูด",
        },
      ],
    };
  },

  components: {
    navbar,
    Multiselect,
  },
  created() {
    this.prepareData();
  },
  computed: {
    ...mapState({
      accessToken: (state) => state.AuthModule.accessToken,
      user: (state) => state.AuthModule.userData,
      community: (state) => state.OptionsModule.community,
      categories: (state) => state.OptionsModule.categories,
      habits: (state) => state.OptionsModule.habits,
      habitats: (state) => {
        if (!state.OptionsModule.habitats) return [];
        return state.OptionsModule.habitats;
      },
      benefits: (state) => state.OptionsModule.benefits,
      province_survey: (state) => state.OptionsModule.province_survey,
      district_survey: (state) => state.OptionsModule.district_survey,
      sub_district_survey: (state) => state.OptionsModule.sub_district_survey,
      province_bank: (state) => state.OptionsModule.province_bank,
      district_bank: (state) => state.OptionsModule.district_bank,
      sub_district_bank: (state) => state.OptionsModule.sub_district_bank,
      province: (state) => state.OptionsModule.province,
      district: (state) => state.OptionsModule.district,
      sub_district: (state) => state.OptionsModule.sub_district,
      // knowledge_level1s: (state) => state.OptionsModule.knowledge_level1s,
      knowledge: (state) => state.OptionsModule.knowledge,
      form: (state) => state.formSurveyModule.form,
    }),
  },
  methods: {
    prepareData() {
      Swal.fire({
        title: "ระบบกำลังทำงาน",
        html: "โปรดรอสักครู่...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
          this.$store.dispatch("OptionsModule/onGetOption").then(() => {
            this.categories.forEach((item) => {
              this.categoriesOption.push({
                id: item.category_id,
                name: item.name,
              });
            });
            this.habits.forEach((item) => {
              this.habitsOption.push({ id: item.habit_id, name: item.name });
            });
            for (const item of this.habitats) {
              this.habitatsOption.push({
                id: item.habitat_id,
                name: item.name,
              });
            }
            let data = this.form.benefit;
            let arr = [];
            this.benefits.forEach((item) => {
              this.benefitsOption.push({
                id: item.benefit_id,
                name: item.name,
              });
              arr.push({
                id: item.benefit_id,
                name: item.name,
              });
            });
            data.forEach((item) => {
              arr.forEach((option) => {
                if (item.benefit_id === option.id) {
                  option.isChecked = item.benefit_description ? true : false;
                  option.benefit_description = item.benefit_description;
                  option.benefit_id = item.benefit_id;
                  option.community_id = item.community_id;
                  option.created_at = item.created_at;
                  option.created_by = item.created_by;
                  option.id = item.id;
                  option.plant_id = item.plant_id;
                  option.updated_at = item.updated_at;
                  option.updated_by = item.updated_by;
                }
              });
            });
            this.$store.dispatch("formSurveyModule/bypassBenefit", arr);
            this.setMasterData();
          });

          Swal.fire({
            icon: "success",
            title: "เรียบร้อย",
            timer: 1500,
            showConfirmButton: false,
          });

          Swal.hideLoading();
        },
      });
    },
    getTooltip(key) {
      let Name = this.tooltipName.filter((tooltip) => {
        return tooltip.name == key;
      });
      return Name[0].tooltip_name;
    },

    prepareKnowLedge() {
      let tempForm = [];
      this.form.plant_knowledges.forEach((value, index) => {
        if (value.knowledge_description) {
          this.checkInput[value.knowledges1.knowledge_level1_id] = true;
          this.checkInput[
            value.knowledges1.knowledge_level1_id +
              "_" +
              value.knowledges1.knowledge_level2_id
          ] = true;
        }
        tempForm[value.knowledge_id] = value.knowledge_description;
      });
      this.form.knowledge = tempForm;
    },

    async getDistrict(province, name) {
      let filter = [];
      filter = this.district.filter((data) => {
        return data.province_id == province.code;
      });
      let data = {
        name: name,
        filter: filter,
      };
      this.$store.dispatch("OptionsModule/setFilterDistrict", data);
    },
    async getSubDistrict(district, name) {
      let filter = [];
      filter = this.sub_district.filter((data) => {
        return data.district_id == district.district_id;
      });
      let data = {
        name: name,
        filter: filter,
      };
      this.$store.dispatch("OptionsModule/setFilterSubDistrict", data);
    },
    getHabitat(id) {
      let filter = [];
      filter = this.habitats.filter((data) => {
        return data.habitat_id == id;
      });
      let data = {
        id: id,
        name: filter[0].name,
      };
      return data;
    },
    setProvince(id) {
      let filter = [];
      filter = this.province.filter((data) => {
        return data.code == id;
      });
      let data = {
        id: id,
        name: filter[0].name,
      };
      return data;
    },
    setDistrict(id) {
      let filter = [];
      filter = this.district.filter((data) => {
        return data.district_id == id;
      });
      let data = {
        id: id,
        name: filter[0].name,
      };
      return data;
    },
    setSubDistrict(id) {
      let filter = [];
      filter = this.sub_district.filter((data) => {
        return data.subdistrict_id == id;
      });
      let data = {
        id: id,
        name: filter[0].name,
      };
      return data;
    },
    setMasterData() {
      if (this.form.category) {
        this.category_selected = {
          id: this.form.category_id,
          name: this.form.category.name,
        };
      }
      if (this.form.habit) {
        this.habit_selected = {
          id: this.form.habit_id,
          name: this.form.habit.name,
        };
      }
      if (this.form.habitat && this.habitats) {
        let filter = this.habitats.filter((data) => {
          return data.habitat_id == this.form.habitat;
        });
        let data = {};
        if (filter.length > 0) {
          data = {
            id: this.form.habitat,
            name: filter[0].name,
          };
        }

        this.habitat_selected = data;
      }
      if (this.form.survey_plot_province) {
        this.province_survey_selected = this.setProvince(
          this.form.survey_plot_province
        );
      }
      if (this.form.survey_plot_district) {
        this.district_survey_selected = this.setDistrict(
          this.form.survey_plot_district
        );
      }
      if (this.form.survey_plot_sub_district) {
        this.sub_district_survey_selected = this.setSubDistrict(
          this.form.survey_plot_sub_district
        );
      }
      if (this.form.bank_plot_province) {
        this.province_bank_selected = this.setProvince(
          this.form.bank_plot_province
        );
      }
      if (this.form.bank_plot_district) {
        this.district_bank_selected = this.setDistrict(
          this.form.bank_plot_district
        );
      }
      if (this.form.bank_plot_sub_district) {
        this.sub_district_bank_selected = this.setSubDistrict(
          this.form.bank_plot_sub_district
        );
      }
      if (this.form.community_id) {
        let communityModel = this.community.find(
          (x) => x.community_id === this.form.community_id
        );
        this.community_code = communityModel.community_code;
      }
      this.prepareDataAddressIsNull();
      this.prepareKnowLedge();
    },
    prepareDataAddressIsNull() {
      let temp_data = [
        {
          id: 0,
          name: "ไม่ได้กรอกข้อมูล",
        },
      ];

      if (!this.form.survey_plot_province) {
        this.province_survey_selected = temp_data;
      }
      if (!this.form.survey_plot_district) {
        this.district_survey_selected = temp_data;
      }
      if (!this.form.survey_plot_sub_district) {
        this.sub_district_survey_selected = temp_data;
      }
      if (!this.form.bank_plot_province) {
        this.province_bank_selected = temp_data;
      }
      if (!this.form.bank_plot_district) {
        this.district_bank_selected = temp_data;
      }
      if (!this.form.bank_plot_sub_district) {
        this.sub_district_bank_selected = temp_data;
      }
    },
  },
};
</script>

<style lang="scss">
ol,
ul,
dl {
  margin: 0 !important;
}

.vux-uploader_hd {
  display: block !important;
}

.vux-uploader .vux-uploader_hd .vux-uploader_title {
  display: block !important;
  text-align: center !important;
}

.vux-uploader .vux-uploader_bd .vux-uploader_files {
  list-style: none;
  padding: 0;
}

.vux-uploader .vux-uploader_bd {
  overflow: hidden;
  margin-left: 0 !important;
  margin-right: auto !important;
  padding: 0 !important;
  display: flex;
  justify-content: center;
  margin: 0;
}

.vux-uploader .vux-uploader_bd .vux-uploader_input-box {
  float: left;
  position: relative;
  margin: 0;

  width: 77px;
  height: 77px;
  border: 1px solid #d9d9d9;
}
</style>
